import CheckoutStepper from '@components/CheckoutStepper';
import { isMobileApp } from '@utils/environment';
import Arrow from '@monofront/design-system/visuals/Icons/Old/Arrow';
import Close from '@monofront/design-system/visuals/Icons/Old/Close';
import Button from '@monofront/design-system/components/Button';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import useLabels from '../useLabels';
import { ICheckoutSteps } from '@hooks/useCheckoutSteps';

interface IHeaderMobileProps {
  step: ICheckoutSteps;
  title?: string | React.ReactNode;
  isStepperDisplayed?: boolean;
}

const HeaderMobile: React.FC<IHeaderMobileProps> = ({
  step,
  title,
  isStepperDisplayed = true,
}) => {
  const router = useRouter();

  const { titleLabels } = useLabels();
  const tGlobal = useTranslations('Global');

  return (
    <>
      {!isMobileApp && (
        <div className="header-mobile-container mobile-only">
          <Button
            variant="clear"
            onClick={() => router.back()}
            dataTestId="HeaderMobile-Icon-go-back"
            ariaLabel={tGlobal('back')}
          >
            <Arrow width={14} height={14} headDirection="left" aria-hidden />
          </Button>
          <h1>{title || titleLabels[step]}</h1>
          <Button
            variant="clear"
            onClick={() => router.push('/cart')}
            dataTestId="HeaderMobile-Close-go-to-cart"
            ariaLabel={tGlobal('close')}
          >
            <Close width={12} height={12} aria-hidden />
          </Button>
        </div>
      )}

      {isStepperDisplayed && (
        <div className="stepper mobile-only">
          <CheckoutStepper currentStep={step} />
        </div>
      )}
      <style jsx>{`
        .header-mobile-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: var(--checkout-header-height);
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: var(--padding-layout-sm);
          background-color: var(--white);
          z-index: var(--zindex-fixed);
        }
        .header-mobile-container > :global(span) {
          margin: 0;
        }
        .header-mobile-container > h1 {
          font-size: var(--font-size-1-5);
          max-width: 65%;
          text-align: center;
        }

        .stepper {
          margin-top: var(--checkout-header-height);
          padding: 0 var(--space-5);
        }
      `}</style>
    </>
  );
};

export default HeaderMobile;
